module.exports = __webpack_public_path__ + "assets/36fe86010c4148ec4ca0b562b02d21278.jpg";